<template>
    <div>
        <div class="complianceChecksDetail-title">
            <Breadcrumb>
                <BreadcrumbItem>{{$t('alarms.complianceChecks.compliance')}}</BreadcrumbItem>
                <BreadcrumbItem to="/monitor/complianceChecks">{{$t('alarms.complianceChecks.Details')}}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <div class="search">
            <Row :gutter="4">
                <Col span="4">
                    <Select v-model="resourceState" filterable :placeholder="$t('alarms.complianceChecks.FilterbyResourceComplianceStatus')"  @on-change="changeResourceState()" :transfer="true">
                        <Option value="" selected>{{$t('alarms.common.all')}}</Option>
                        <Option :value="item.id" v-for="item in resourceStateList" :key="item.name">{{item.name}}</Option>
                    </Select>
                </Col>
                <Col span="2">
                  <Button @click="goBack">{{ $t('alarms.common.back') }}</Button>
                </Col>
            </Row>
        </div>
        <Table :no-data-text="$t('common.noData')" :columns="column" :data="complianceChecksDetailDate" :height="550" style="width: 100.1%;">
        </Table>
        <!-- 忽略模式框 -->
        <Modal v-model="ignoreModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f90;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{$t('alarms.complianceChecks.IgnoreConfirmation')}}</span>
            </p>
            <div style="text-align:center">
                <p>{{$t('alarms.complianceChecks.AreyouSureWantToIgnore')}}</p>
            </div>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="modal_loading_ignore" @click="ignoreNoncompliantResources()" :disabled="isDisableIgnore">{{$t('alarms.complianceChecks.Ignore')}}</Button>
            </div>
        </Modal>
        <!-- 恢复模式框 -->
        <Modal v-model="restoreModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f90;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{$t('alarms.complianceChecks.RestoreConfirmation')}}</span>
            </p>
            <div style="text-align:center">
                <p>{{$t('alarms.complianceChecks.AreYouSureWantToRestore')}}</p>
            </div>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="modal_loading_restore" @click="deleteIgnoreNoncompliantResources()" :disabled="isDisableRestore">{{$t('alarms.complianceChecks.Restore')}}</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: 'ComplianceChecksDetail',
        components: {
        },
        data(){
            return {
                ignoreModal:false,
                modal_loading_ignore: false,
                isDisableIgnore: false, //忽略
                restoreModal:false,
                modal_loading_restore: false,
                isDisableRestore: false, //恢复
                resourceState:'',
                resourceStateList:[{
                    id:0,
                    name:this.$t('alarms.complianceChecks.NonCompliant')
                },
                {
                    id:1,
                    name:this.$t('alarms.complianceChecks.Compliance')
                }],
                column:[
                  {
                    title:this.$t('alarms.complianceChecks.Account'),
                    key:'accountName'
                  },
                  {
                    title:this.$t('alarms.complianceChecks.Area'),
                    key:'region'
                  },
                  {
                    title:this.$t('alarms.complianceChecks.ResourceID'),
                    key:'resourceId'
                  },
                  {
                    title:this.$t('alarms.complianceChecks.ResourceType'),
                    key:'resourceType'
                  },
                  {
                      title:this.$t('alarms.complianceChecks.ResourceComplianceStatus'),
                      key:'complianceType'
                  }
                ],
                complianceChecksDetailDate:[]
            }
        },
        mounted () {
            this.queryConfigRuleCheckItemsDetail();
        },
        methods: {
            // 返回上一页
            goBack:function(){
              window.history.go(-1);
            },
            // 表格
            queryConfigRuleCheckItemsDetail:function(){
            	this.$api.awsConfigCheckItem.queryConfigRuleCheckItemsDetail({
                    "accountId":this.$route.query.accountId,
                    "region":this.$route.query.region,
                    "configRuleName":this.$route.query.configRuleName,
                    "complianceType":this.resourceState
                })
                .then(res => {
                    this.complianceChecksDetailDate=res.data;
                })
            },
            /*****************资源合规性状态**********************/
            // 切换资源合规性状态
            changeResourceState:function(){
                this.queryConfigRuleCheckItemsDetail();
            }
        }
    }
</script>

<style scoped>
    .complianceChecksDetail-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .search
    {
        height: 45px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/compliance_checks/complianceChecks_list/ComplianceChecksDetail.vue